module.exports = __webpack_public_path__ + "images/ed4d815d8b6372b4ed72b909dd9b359c52e7e7f1df53082092b6cbcd58072ec7.svg";